import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UsersDataSlice = createSlice({
    name: "usersDataList",
    initialState,
    reducers: {
        usersDataListRequest(state) {
            state.loading = true;
        },
        usersDataListRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        usersDataListRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    usersDataListRequest,
    usersDataListRequestSuccess,
    usersDataListRequestError,
} = UsersDataSlice.actions;

export default UsersDataSlice.reducer;
